export default __webpack_public_path__ + "static/media/2.fd4e9772.webp";